import { WindowEvent } from "../windowEvent.service";

type InfoblockOpenedEventDetail = undefined;

export class InfoblockOpenedEvent extends CustomEvent<InfoblockOpenedEventDetail> {
    constructor() {
        super(WindowEvent.InfoblockOpened);
    }
}
